module.exports = __webpack_public_path__ + "static/media/November_2026_2.86e42d18.webp";